import React from 'react'
import zingchart from 'zingchart/es6'
import propTypes from 'prop-types'
import ZingChart from 'zingchart-react'
import BarChartConfig from './BarChartConfig'
import { useEffect } from 'react'

const BarChart = (props) => {
	const chartId = props.chartId

	useEffect(() => {
		const handleNodeClick = (e) => {
			const series = props.series
			if (!series || series.length === 0) return

			const categories = props.categories || []
			let identifier
			if (categories.length > 0) {
				identifier = categories[e.nodeindex]
			} else {
				identifier = series[e.nodeindex]?.identifier
			}

			if (props.onSliceClick) {
				props.onSliceClick(identifier)
			}
		}

		zingchart.bind(chartId, 'node_click', handleNodeClick)

		return () => {
			zingchart.unbind(chartId, 'node_click', handleNodeClick)
		}
	}, [props, props.series, chartId])

	const charData = BarChartConfig(
		props.title,
		props.subtitle,
		props.series,
		props.categories
	)

	return (
		<div>
			<ZingChart
				data={charData}
				id={props.chartId}
			/>
		</div>
	)
}

BarChart.propTypes = {
	series: propTypes.array.isRequired, // Now expects array of series arrays
	categories: propTypes.array,        // Array of categories (e.g., models)
	title: propTypes.string,
	subtitle: propTypes.string,
	chartId: propTypes.string.isRequired,
	onSliceClick: propTypes.func
}
BarChart.defaultProps = {
	series: [],
	categories: [],
	title: '',
	subtitle: '',
	onSliceClick: undefined
}
export default BarChart
